if (!customElements.get("bundle-form")) {
    class BundleForm extends HTMLElement {
        constructor() {
            super();
            this.maxTotal = 3;
            this.resolvedVariantId = null;
        }

        connectedCallback() {
            this.products = Array.from(
                this.querySelectorAll(".your-bundle-products__product")
            );

            this.initQuantityButtons();
            this.initBundleSelectListener();
            this.initFlavorVisibilityListener();
            this.initCartGuard();
            this.initVariantIdGuard();
            this.syncLoopSupplyVisibility();
            this.syncFromUrlVariant();
            this.applyBundleVariant();
        }

        getCurrentVariantId() {
            const url = new URL(window.location.href);
            const variantParam = url.searchParams.get("variant");
            if (variantParam) return parseInt(variantParam, 10);
            const variantInput =
                document.querySelector('[data-form-wrapper] input[name="id"]') ||
                document.querySelector('input[type="hidden"][name="id"][form]');
            return variantInput?.value ? parseInt(variantInput.value, 10) : null;
        }

        setOptionByValue(wrapper, value) {
            if (!wrapper || !value) return false;
            var input = wrapper.querySelector('input[data-single-option-selector][value="' + CSS.escape(value) + '"]');
            if (!input || input.checked) return false;
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            return true;
        }

        selectYourBundleAndSetQuantities(counts) {
            const flavorWrapper = this.getFlavorWrapper();
            if (!flavorWrapper) return;
            const bundleInput = flavorWrapper.querySelector('input[value="bundle"]');
            if (!bundleInput) return;

            this.products.forEach((block) => {
                const flavor = block.dataset.value.toLowerCase();
                const input = block.querySelector(".your-bundle-products__quantity-input");
                if (input) input.value = counts[flavor] || 0;
            });
            this.updateButtonsState();

            if (!bundleInput.checked) {
                bundleInput.checked = true;
                bundleInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }

        syncFromUrlVariant() {
            const variantId = this.getCurrentVariantId();
            if (!variantId) return;

            const product = this.getProductJson();
            if (!product?.variants) return;

            const variant = product.variants.find((v) => v.id === variantId);
            if (!variant || !variant.options || variant.options.length < 2) return;

            const flavorIndex = this.getFlavorOptionIndex();
            const flavorOption = variant.options[flavorIndex];
            if (!flavorOption || (flavorOption.indexOf(" x") === -1 && flavorOption.indexOf(" + ") === -1)) return;

            const counts = {};
            flavorOption.split("+").forEach((part) => {
                const match = part.trim().match(/^(\w+)\s*x(\d+)$/i);
                if (match) {
                    counts[match[1].toLowerCase()] = parseInt(match[2], 10);
                }
            });

            if (Object.keys(counts).length === 0) return;

            window.__bundleFormSyncing = true;

            this.selectYourBundleAndSetQuantities(counts);

            const daysWrapper = this.getDaysWrapper();
            const daysIndex = this.getDaysOptionIndex();
            if (daysWrapper && variant.options[daysIndex]) {
                this.setOptionByValue(daysWrapper, variant.options[daysIndex]) ||
                this.setOptionByLabelDataValue(daysWrapper, "90-days-up-to-an-extra-10-off");
            }

            this.updateBundlePrice(variant);
            this.updateBundleShopPayTerms(variant.id);
            setTimeout(() => {
                this.forceBundleButtonAvailable();
                window.__bundleFormSyncing = false;
            }, 0);
        }

        initBundleSelectListener() {
            const container = this.closest("product-form") || this.closest("form") || document;
            container.addEventListener("change", (e) => {
                if (window.__bundleFormSyncing || window.__loopSupplySelectorSyncing) return;
                if (!this.isYourBundleSelected()) return;

                const input = e.target;
                if (input.matches?.("input[data-single-option-selector]") && input.value === "bundle") {
                    if (this.getStateParts().length !== 2) {
                        this.setDefaultQuantities();
                    }
                }

                if (input.matches?.(".your-bundle-products__quantity-input")) {
                    this.syncLoopSupplyVisibility();
                }

                if (
                    input.matches?.("input[data-single-option-selector]") ||
                    input.matches?.(".your-bundle-products__quantity-input")
                ) {
                    setTimeout(() => {
                        this.applyBundleVariant();
                    }, 50);
                }
            });
        }

        initFlavorVisibilityListener() {
            document.addEventListener("change", (event) => {
                const input = event.target;
                if (!input?.matches?.('input[data-single-option-selector]')) return;

                const flavorWrapper = this.getFlavorWrapper();
                if (!flavorWrapper?.contains(input)) return;

                window.setTimeout(() => {
                    this.syncLoopSupplyVisibility();
                    if (this.isYourBundleSelected()) {
                        this.applyBundleVariant();
                    }
                }, 0);
            });
        }

        isMixedFlavorBundle() {
            if (!this.isYourBundleSelected()) return false;
            return this.getStateParts().length > 1;
        }

        syncLoopSupplyVisibility() {
            this.updateLoopSupplyAvailability(this.isMixedFlavorBundle());
        }

        getSelectedLoopSupplyDays() {
            const selected = document.querySelector(
                "[data-loop-widget-purchase-option].loop-widget-purchase-option-selected[data-loop-supply-days]"
            );
            const days = Number.parseInt(selected?.getAttribute("data-loop-supply-days") || "", 10);
            return days === 30 || days === 90 ? days : null;
        }

        getDaysValueForSupplyDays(supplyDays) {
            if (supplyDays === 30) return "30 days";
            if (supplyDays === 90) return "90 days";

            const daysWrapper = this.getDaysWrapper();
            if (daysWrapper) {
                const checkedRadio = daysWrapper.querySelector('input[type="radio"][data-single-option-selector]:checked');
                if (checkedRadio?.value) return checkedRadio.value;

                const popout = daysWrapper.querySelector("input[data-popout-input]");
                if (popout?.value) return popout.value;
            }

            return "90 days";
        }

        updateLoopSupplyAvailability(isMixedFlavorBundle) {
            const thirtyOptions = document.querySelectorAll(
                '[data-loop-supply-days="30"][data-loop-widget-purchase-option]'
            );
            const ninetyOption = document.querySelector(
                '[data-loop-supply-days="90"][data-loop-widget-purchase-option]'
            );
            const shouldHideThirty = this.isYourBundleSelected() && isMixedFlavorBundle;

            thirtyOptions.forEach((option) => {
                option.hidden = shouldHideThirty;
            });

            if (!shouldHideThirty) return;

            const thirtySelected = document.querySelector(
                '[data-loop-supply-days="30"][data-loop-widget-purchase-option].loop-widget-purchase-option-selected'
            );
            if (thirtySelected && ninetyOption) {
                this.syncLoopSupplyDays(90);
            }
        }

        setDefaultQuantities() {
            this.products.forEach((block) => {
                const flavor = block.dataset.value.toLowerCase();
                const input = block.querySelector(".your-bundle-products__quantity-input");
                if (input) {
                    input.value = flavor === "chocolate" ? 2 : 1;
                }
            });
            this.updateButtonsState();
        }

        getFlavorWrapper() {
            const sel = document.querySelector(".product__selectors");
            return sel?.querySelector('.selector-wrapper[data-option-handle="pick-flavor"]') || null;
        }

        getDaysWrapper() {
            const sel = document.querySelector(".product__selectors");
            return sel?.querySelector('.selector-wrapper[data-option-handle="days-of-supply"]') || null;
        }

        getProductJson() {
            const el = document.querySelector("script[data-product-json]");
            if (!el || !el.textContent) return null;
            try {
                return JSON.parse(el.textContent);
            } catch (_) {
                return null;
            }
        }

        getDaysOptionIndex() {
            const product = this.getProductJson();
            if (!product?.options) return 0;
            const idx = product.options.findIndex((name) => /day|supply/i.test(String(name)));
            return idx >= 0 ? idx : 0;
        }

        getFlavorOptionIndex() {
            const product = this.getProductJson();
            if (!product?.options) return 1;
            const idx = product.options.findIndex((name) => /flavor|flavour/i.test(String(name)));
            return idx >= 0 ? idx : 1;
        }

        findVariantByOptions(daysValue, flavorValue) {
            const product = this.getProductJson();
            if (!product?.variants || !flavorValue) return null;

            const daysIndex = this.getDaysOptionIndex();
            const flavorIndex = this.getFlavorOptionIndex();

            return (
                product.variants.find(function (v) {
                    if (!v.options) return false;
                    return v.options[daysIndex] === daysValue && v.options[flavorIndex] === flavorValue;
                }) || null
            );
        }

        getFlavorLabel(block) {
            return block?.dataset?.flavorValue || block?.dataset?.value || "";
        }

        initCartGuard() {
            const syncBeforeCart = () => {
                if (!this.isYourBundleSelected()) return;
                this.applyBundleVariant();
            };

            document.addEventListener("theme:cart:add", syncBeforeCart, true);
            document.addEventListener(
                "click",
                (event) => {
                    if (event.target.closest("[data-add-to-cart]")) syncBeforeCart();
                },
                true
            );
        }

        initVariantIdGuard() {
            document.addEventListener(
                "change",
                (event) => {
                    if (window.__bundleFormSyncing || window.__loopSupplySelectorSyncing) return;
                    if (!this.isYourBundleSelected()) return;
                    if (!event.target?.matches?.('input[name="id"]')) return;
                    if (!this.resolvedVariantId) return;
                    if (event.target.value) return;
                    this.setVariantIdDirectly(this.resolvedVariantId);
                },
                true
            );
        }

        syncLoopWidgetForVariant(variant) {
            if (!variant?.id) return;

            document
                .querySelectorAll('loop-subscription-widget-manual[data-supply-selector-mode="true"][data-initialized="true"]')
                .forEach((widget) => {
                    if (typeof widget.setVariantId === "function") {
                        widget.setVariantId(variant.id, { dispatchChange: false });
                    }
                });
        }

        syncLoopSupplyDays(supplyDays) {
            const option = document.querySelector(
                `[data-loop-widget-purchase-option][data-loop-supply-days="${supplyDays}"]`
            );
            if (!option || option.classList.contains("loop-widget-purchase-option-selected")) return;

            const widget = option.closest("loop-subscription-widget-manual");
            if (widget && typeof widget.selectOption === "function") {
                widget.selectOption(option, { userInitiated: false });
                return;
            }

            option.click();
        }

        commitBundleVariant(variant, options = {}) {
            if (!variant?.id) return false;

            this.resolvedVariantId = variant.id;
            this.setVariantIdDirectly(variant.id);
            this.updateBundlePrice(variant);
            this.updateBundleShopPayTerms(variant.id);
            this.syncLoopWidgetForVariant(variant);

            if (options.updateUrl !== false) {
                this.updateUrlWithVariantId();
            }

            if (options.forceAvailable !== false) {
                setTimeout(() => this.forceBundleButtonAvailable(), 0);
            }

            return true;
        }

        setVariantIdDirectly(variantId) {
            const variantInput =
                document.querySelector('[data-form-wrapper] input[name="id"]') ||
                document.querySelector('input[type="hidden"][name="id"][form]') ||
                document.querySelector('product-form input[name="id"]') ||
                document.querySelector('input[name="id"]');
            if (!variantInput) return false;
            variantInput.value = String(variantId);
            variantInput.removeAttribute("disabled");
            variantInput.dispatchEvent(new Event("change", { bubbles: true }));
            return true;
        }

        setOptionByLabelDataValue(wrapper, targetDataValue) {
            if (!wrapper || !targetDataValue) return false;
            var label = wrapper.querySelector('label[data-value="' + CSS.escape(targetDataValue) + '"]');
            if (!label) return false;
            var input = label.closest(".radio__button")?.querySelector("input[data-single-option-selector]") || (label.htmlFor ? document.getElementById(label.htmlFor) : null);
            if (!input || input.checked) return false;
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            return true;
        }

        initQuantityButtons() {
            this.products.forEach((productDiv) => {
                const qtyInput = productDiv.querySelector(".your-bundle-products__quantity-input");
                const btns = productDiv.querySelectorAll(".your-bundle-products__quantity-btn");

                btns.forEach((btn) => {
                    btn.addEventListener("click", (e) => {
                        e.preventDefault();
                        if (btn.disabled) return;
                        this.updateQuantity(qtyInput, btn);
                        this.applyBundleVariant();
                    });
                });
            });
            this.updateButtonsState();
        }

        updateButtonsState() {
            this.products.forEach((productDiv) => {
                const qtyInput = productDiv.querySelector(".your-bundle-products__quantity-input");
                const minusBtn = productDiv.querySelector(".your-bundle-products__quantity-btn.minus");
                const plusBtn = productDiv.querySelector(".your-bundle-products__quantity-btn.plus");
                const val = Number(qtyInput?.value || 0);

                if (minusBtn) {
                    minusBtn.disabled = val <= 0;
                }
                if (plusBtn) {
                    plusBtn.disabled = val >= 3;
                }
            });
        }

        updateQuantity(input, btn) {
            const val = Number(input.value);
            let newValue = val;
            const isIncrement = btn.classList.contains("plus");

            if (isIncrement) {
                newValue = Math.min(val + 1, 3);
            } else {
                newValue = Math.max(val - 1, 0);
            }

            if (newValue !== val) {
                input.value = newValue;
                this.syncOtherQuantity(input);
                this.updateButtonsState();
            }
        }

        syncOtherQuantity(changedInput) {
            const currentTotal = Number(changedInput.value);
            const otherProduct = this.products.find(
                (pd) => pd.querySelector(".your-bundle-products__quantity-input") !== changedInput
            );
            if (!otherProduct) return;
            const otherInput = otherProduct.querySelector(".your-bundle-products__quantity-input");
            if (!otherInput) return;
            otherInput.value = this.maxTotal - currentTotal;
        }

        getStateParts() {
            return this.products
                .map((block) => {
                    const flavorLabel = this.getFlavorLabel(block);
                    const flavorKey = (block.dataset.value || flavorLabel).toLowerCase();
                    const qty = Number(block.querySelector(".your-bundle-products__quantity-input").value);
                    if (qty > 0) {
                        return { flavor: flavorKey, flavorLabel, qty };
                    }
                    return null;
                })
                .filter(Boolean);
        }

        statePartsToPackValue(stateParts) {
            if (!stateParts || stateParts.length === 0) return null;
            const sorted = [...stateParts].sort((a, b) => {
                if (b.qty !== a.qty) return b.qty - a.qty;
                return a.flavor.localeCompare(b.flavor);
            });
            const labelFor = (part) => {
                if (part.flavorLabel) return part.flavorLabel;
                return part.flavor.charAt(0).toUpperCase() + part.flavor.slice(1).toLowerCase();
            };
            return sorted.map((p) => labelFor(p) + " x" + p.qty).join(" + ");
        }

        getSingleFlavorValue(stateParts) {
            if (!stateParts?.length || stateParts.length !== 1) return null;
            const part = stateParts[0];
            return part.flavorLabel || part.flavor.charAt(0).toUpperCase() + part.flavor.slice(1).toLowerCase();
        }

        applyBundleVariant() {
            if (!this.isYourBundleSelected()) return null;

            const stateParts = this.getStateParts();
            const packValue = this.statePartsToPackValue(stateParts);
            if (!packValue) return null;

            const isMixedFlavorBundle = stateParts.length > 1;
            this.syncLoopSupplyVisibility();

            window.__bundleFormSyncing = true;

            const loopSupplyDays = isMixedFlavorBundle ? 90 : this.getSelectedLoopSupplyDays();
            const daysValue = this.getDaysValueForSupplyDays(loopSupplyDays);
            const daysWrapper = this.getDaysWrapper();

            if (daysWrapper && daysValue) {
                this.setOptionByValue(daysWrapper, daysValue) ||
                    (daysValue === "90 days"
                        ? this.setOptionByLabelDataValue(daysWrapper, "90-days-up-to-an-extra-10-off")
                        : false);
            }

            let variant = null;

            if (stateParts.length === 1 && Number(stateParts[0].qty) === 3) {
                const flavorValue = this.getSingleFlavorValue(stateParts);
                variant = this.findVariantByOptions(daysValue, flavorValue);
            } else {
                variant = this.findVariantByOptions(daysValue, packValue);
            }

            if (variant) {
                this.commitBundleVariant(variant);
            }

            window.__bundleFormSyncing = false;
            return variant;
        }

        isYourBundleSelected() {
            const flavorWrapper = this.getFlavorWrapper();
            if (!flavorWrapper) return false;
            const checked = flavorWrapper.querySelector('input[type="radio"][data-single-option-selector]:checked');
            return checked && checked.value === "bundle";
        }

        updateUrlWithVariantId() {
            const variantInput = document.querySelector('input[type="hidden"][name="id"][form]');
            if (!variantInput?.value) return;
            const url = new URL(window.location.href);
            url.searchParams.set("variant", variantInput.value);
            window.history.replaceState(window.history.state || {}, "", url.toString());
        }

        updateBundleShopPayTerms(variantId) {
            const scope = this.closest("product-form") || this.closest(".product__content") || document;
            const installmentForms = scope.querySelectorAll("[data-product-form-installment]");
            installmentForms.forEach((form) => {
                const installmentInput = form.querySelector('input[name="id"]');
                if (!installmentInput) return;
                installmentInput.value = variantId;
                installmentInput.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        updateBundlePrice(variant) {
            if (!variant || typeof theme === "undefined") return;
            const scope = this.closest("product-form") || this.closest(".product__content") || document;
            const priceEls = scope.querySelectorAll("[data-product-price]");
            const price = variant.price || 0;
            const comparePrice = variant.compare_at_price;
            const formatMoney = window.theme?.formatMoney;
            const moneyFormat = theme?.moneyFormat;
            if (!formatMoney || !moneyFormat) return;

            priceEls.forEach((el) => {
                const wrap = el.closest("[data-price-wrapper]");
                const compareEl = wrap?.querySelector("[data-compare-price]");
                el.innerHTML = price === 0 ? (theme.strings?.free || "Free") : formatMoney(price, moneyFormat);
                if (comparePrice && comparePrice > price) {
                    el.classList.add("product__price--sale");
                    if (compareEl) compareEl.innerHTML = formatMoney(comparePrice, moneyFormat);
                } else {
                    el.classList.remove("product__price--sale");
                    if (compareEl) compareEl.innerHTML = "";
                }
            });
        }

        forceBundleButtonAvailable() {
            if (!this.isYourBundleSelected()) return;
            const formWrappers = document.querySelectorAll("[data-form-wrapper]");
            formWrappers.forEach((el) => {
                el.classList.remove("variant--soldout", "variant--unavailable");
            });
            const variantInput =
                document.querySelector('product-form input[name="id"]') ||
                document.querySelector('input[name="id"]');
            if (variantInput) {
                variantInput.removeAttribute("disabled");
            }
            const addBtns = document.querySelectorAll(
                'button.product-information__atc, button[name="add"][data-add-to-cart], button[data-add-to-cart-bar]'
            );
            addBtns.forEach((btn) => {
                btn.removeAttribute("disabled");
                btn.removeAttribute("aria-disabled");
                const textEl = btn.querySelector("[data-add-to-cart-text]");
                const addText = (typeof theme !== "undefined" && theme.strings?.addToCart) || "Add to cart";
                if (textEl) {
                    textEl.textContent = addText;
                } else {
                    btn.textContent = addText;
                }
            });
        }
    }

    customElements.define("bundle-form", BundleForm);
}


